<template>
  <v-app>
    <Authentication
      :register="null"
      :resetPassword="null"
      :cancel="'Cancel'"
      :success="true"
      :operationField="'appConfirm'"
      :transactionField="'confirmTran'"
      :registerField="null"
      :resetPasswordField="null"
      :maxWidth="'500'"
      :inputUserName="true"
      @transaction-process="transactionProcess"
      @close-dialog="closeDialog"
    />
  </v-app>
</template>

<script>
import { environment } from "./../../../environment/environment.js";
import Authentication from "./Authentication";

export default {
  name: "Confirm",
  props: [],
  data() {
    return {
      environment: environment,
      confirmSuccess: false,
      userName: null,
    };
  },
  components: {
    Authentication,
  },
  methods: {
    transactionProcess(data) {
      this.confirmSuccess = data.success == true;
    },

    closeDialog(data) {
      if (this.confirmSuccess) {
        this.goToLogin(data.applicationName);
      }
    },
  },
  created() {
    
  },
};
</script>

<style>
</style>